import { useContext } from 'react';
import { CognitoAuthContext } from '@/contexts';

export const useAuth = () => {
  const context = useContext(CognitoAuthContext);

  if (!context) {
    throw new Error('useAuth must be used within a CognitoAuthProvider');
  }

  return context;
};
